import React, { useState, useEffect } from 'react';
import Header     from './Header';
import Hero       from './Hero';
import About      from './About';
import Experience from './Experience';
import Project    from './Project';
import Skill      from './Skill';
import Education  from './Education';
import ContactUs  from './ContactUs';
import Footer     from '../Footer/Footer';

function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!visible) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
      className="fixed bottom-8 right-8 z-40 w-11 h-11 bg-sky-500 hover:bg-sky-400 text-white rounded-xl shadow-lg shadow-sky-500/30 flex items-center justify-center transition-all hover:shadow-sky-400/40 hover:-translate-y-0.5"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
}

export default function App() {
  return (
    <div className="bg-slate-950 font-sans antialiased">
      <Header />
      <main>
        <Hero />
        <About />
        <Experience />
        <Project />
        <Skill />
        <Education />
        <ContactUs />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
